import { Directive, HostListener, HostBinding, ElementRef, Renderer2, Optional, Host } from '@angular/core';
import { AutoSuggestComponent } from '@otas/utils/custom-components/auto-suggest/auto-suggest.component';
import { MultiSelectComponent } from '@otas/utils/custom-components/multi-select/multi-select.component';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '.auto_suggest_footer',
    standalone: false
})
export class AutoSuggestFooterDirective {

  constructor(private el: ElementRef, private renderer: Renderer2,
    @Optional() @Host() private autoSuggestComponentRef: AutoSuggestComponent,
    @Optional() @Host() private multiSelectComponentRef: MultiSelectComponent) {
    // console.log('AutoSuggestFooterDirective', el.nativeElement);
  }
  // @HostBinding('class.active') cssClass = 'active';
  @HostListener('mouseout')
  mouseOut() {
    this.renderer.removeClass(this.el.nativeElement, 'active');
  }

  @HostListener('focus')
  hover() {
    this.renderer.addClass(this.el.nativeElement, 'active');
  }
  @HostListener('blur')
  blur() {
    this.renderer.removeClass(this.el.nativeElement, 'active');
  }
  @HostListener('mouseover')
  mouseover() {
    this.renderer.addClass(this.el.nativeElement, 'active');
  }
  @HostListener('click')
  click() {
    if (this.autoSuggestComponentRef) {
      this.autoSuggestComponentRef.dropDown = false;
    } else if (this.multiSelectComponentRef) {
      this.multiSelectComponentRef.dropDown = false;

    }
  }
  @HostListener('keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (this.autoSuggestComponentRef) {
      this.autoSuggestComponentRef.dropDown = false;
    } else if (this.multiSelectComponentRef) {
      this.multiSelectComponentRef.dropDown = false;

    }    // enter
    if (event.keyCode === 13) {
      event.preventDefault();
      // setTimeout(() => { this.d.focusNext(1); }, 50);

      return;
    }
  }
}
